<template>
    <div class="layer dialogLayer mask50" v-show="visible">

        <div class="dialog white_bg" :class="{roundBorder8 : roundBorder}" :style="'width:' + width + 'px'">

            <div class="dialogBody" :data-image="image" :data-fileid="fileID">
                <tcPlayer ref="videoPlayer" :controlBar="controlBar" :image="image" :fileID="fileID"
                  @ended="onPlayEnded" @ready="onPlayerReady" v-if="visible"/>
            </div>

        </div>
    </div>

</template>

<script>
import dialogPart from '../part/dialogPart';
import tcPlayer from '@comp/mutilMedia/tcPlayer';

import windowHelper from "@util/windowHelper";

const config = {
};
export default {
    name: "videoAdDialog",
    extends : dialogPart,
    components : { tcPlayer },
    props : {
        width: {
            type : Number,
            default : 280
        },
        fileID : {
            type : String,
            default : ''
        },
        image :{
            type : String,
            default :''
        },
    },
    data() {
        return {
            controlBar : {
                playToggle : true,
                progressControl : false,
                volumePanel : false,
                currentTimeDisplay : false,
                durationDisplay : true,
                timeDivider : false,
                playbackRateMenuButton : false,
                fullscreenToggle : true,
                QualitySwitcherMenuButton : true,
            },
        }
    },
    methods : {
        loadVideoByID(id) {
            this.$refs.videoPlayer.loadVideoByID(id);
        },
        onPlayerReady(){
            this.loadVideoByID(this.fileID);
        },
        onPlayEnded() {
            this.$emit('ended');
        }
    },
    mounted() {
        window.videoAd = this;
        let w = windowHelper.getWidth();
        if (w < 640)
        {
            this.width = w;
        }
    }
}
</script>
<style lang="scss" scoped>
.dialogLayer {
    display: grid;
    align-content: center;
    justify-content: center;
}
.dialog {
    min-height: 120px;
}
</style>
